// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4533":"14c63586","4925":"49581797","8688":"47399191","9258":"4ffe8ee3"}[chunkId] + ".chunk.css";
};